import { jsx as e, jsxs as r } from "react/jsx-runtime";
import { Grid as d, Typography as t, Box as f, Paper as y } from "@mui/material";
import { C as I } from "../../pointsGraph-DTJju-rA.js";
import { AttendanceBadge as b } from "./AttendanceBadge.js";
const B = ({ Event: u, Class: a, Attendance: x, studentId: v, onTeacherMessageClick: s }) => {
  const { Staff: n, StartPeriodLabel: l, EndPeriodLabel: p, Body: m, Title: g } = u, c = x.find((o) => o.StudentID === v);
  let h;
  c && (h = /* @__PURE__ */ e(b, { ...c }));
  const i = [];
  return l && i.push(/* @__PURE__ */ r(d, { size: { xs: 6, sm: 3 }, children: [
    /* @__PURE__ */ e(t, { variant: "caption", children: "Period" }),
    /* @__PURE__ */ r(t, { variant: "body2", "data-testid": "period", children: [
      l,
      p !== l && ` - ${p}`
    ] })
  ] })), n && n.length > 0 && i.push(/* @__PURE__ */ r(d, { size: { xs: n.length > 1 ? 12 : 6, sm: n.length > 1 ? 8 : 5 }, children: [
    /* @__PURE__ */ r(t, { variant: "caption", children: [
      "Teacher",
      n.length > 1 && "s"
    ] }),
    /* @__PURE__ */ e(f, { display: "flex", flexWrap: "wrap", gap: 1, "data-testid": "teacher", children: n == null ? void 0 : n.map((o) => /* @__PURE__ */ e(I, { staffId: o.ID, contactId: o.ContactID, label: o.DisplaynameSurname, showMessageIconButton: !0, onContactMessageClick: s || void 0 }, o.ID)) })
  ] })), a != null && a.ClassName && a.ClassName !== g && i.push(/* @__PURE__ */ r(d, { size: { xs: 6, sm: 4 }, children: [
    /* @__PURE__ */ e(t, { variant: "caption", children: "Class" }),
    /* @__PURE__ */ e(t, { variant: "body2", "data-testid": "class", children: a == null ? void 0 : a.ClassName })
  ] })), h && i.push(/* @__PURE__ */ r(d, { size: { xs: 6, sm: 4 }, children: [
    /* @__PURE__ */ e(t, { variant: "caption", children: "Attendance" }),
    /* @__PURE__ */ e(t, { component: "div", variant: "body2", "data-testid": "attendance", children: h })
  ] })), c != null && c.AttendanceNote && i.push(/* @__PURE__ */ r(d, { size: { xs: 12, sm: 6 }, children: [
    /* @__PURE__ */ e(t, { variant: "caption", children: "Attendance Note" }),
    /* @__PURE__ */ e(t, { variant: "body2", children: c.AttendanceNote })
  ] })), m && i.push(/* @__PURE__ */ e(d, { size: { xs: 12 }, children: m })), i.length === 0 ? null : /* @__PURE__ */ e(y, { sx: { p: 2 }, children: /* @__PURE__ */ e(d, { container: !0, spacing: 2, alignItems: "center", children: i }) });
};
export {
  B as EventDetails
};
//# sourceMappingURL=EventDetails.js.map
